import { Badge, Button, Collapsible, CollapsibleContent, CollapsibleTrigger, Icon } from "@qw/ui";

export const BankanGrid = ({ children, count, label }: React.PropsWithChildren & { count: number; label: string }) => (
  <Collapsible defaultOpen={true} className="@container p-3">
    <CollapsibleTrigger asChild>
      <Button variant="ghost" size="sm" className="group">
        <Badge variant="secondary" size="2xs" type="square">
          {count}
        </Badge>
        {label}
        <Icon icon="keyboard_arrow_down" className="transition-transform group-data-[state=open]:rotate-180" />
      </Button>
    </CollapsibleTrigger>
    <CollapsibleContent className="auto-rows-min gap-2 grid grid-cols-1 @lg:grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 @6xl:grid-cols-5 mt-3">
      {children}
    </CollapsibleContent>
  </Collapsible>
);
